import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Button, Form, Table, DatePicker, Select, Tooltip, Spin, Modal } from 'antd';
import { connect } from 'react-redux'
import './index.scss'
import {
    ErrorNotificationIco,
    ModalCloseIco,
    PdfIco, SpinnerIco,
    XlsIco,
} from '../../../../../modules/CustomIcons'
import moment from 'moment'
import SortableColumn from 'components/Table/ColumnSort'
import CustomTooltip from 'components/Tooltip'
import SelectField from 'components/SelectField'
import SearchableColumn from 'components/Table/ColumnSearch'
import { getBusinessDate } from '../../../../../app/services/transfers'
import { financial, dateFormatter } from '../../../../services/helper';
import {
    Account,
    CardsStatement,
    getAccountStatementExcelByIbanRef, getAccountStatementExcelLCByIbanRef, getAccountStatementPdfByIbanRef,
    getAccountStatementPdfLCByIbanRef
} from '../../../../services/account';
import { useActions } from 'hooks/useActions';
import { getCurrentCompany } from '../../../../services/user';
import FullScreenLoading from 'components/FullScreenLoading';
import { useTranslation } from 'react-i18next';
import {
    getCardStatementData,
    getCardStatementDataByPan,
    setCardArray,
    setFilterData,
    setIbanNumber
} from "store/actions/cardStatement";
import locale from "antd/es/date-picker/locale/az_AZ";
import CustomToolTip from "components/Tooltip";
import { useConveyer } from "@egjs/react-conveyer";
import { getCardExtreExcelByPan, getCardExtrePdfByPan } from "../../../../services/BrCards/NewCards";
import { useLocation } from "react-router-dom";
import { secureLocalStorageGet } from '../../../../../app/helpers';
import { getLoggedUserInfo } from '../../../../services/Auth/GetUserInfo';
import OtpInput from 'react-otp-input';
import Timer from 'components/Timer';

const CardStatement: React.FC<any> = ({ cardsStatementData, inProgress, accountArray }) => {

    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement>(null);
    useConveyer(ref, {
        horizontal: true,
    });
    const location = useLocation()

    const [form] = Form.useForm()
    const [selectAccountOptions, setAccountOptions] = useState([])
    const [activeIndexDate, setDateIndex] = useState(1)
    const [businessDate, setBusinessDate] = useState('')
    const [tableData, setTableData] = useState<CardsStatement[]>();
    // const [fromBranch, setFromBranch] = useState<CardsStatement>();
    const [tableListForSortOriginal, setTableListForSortOriginal] = useState<CardsStatement[]>();
    const [tableDataMain, setTableDataMain] = useState<CardsStatement[]>();
    const dateFormat = 'DD.MM.YYYY'
    const [account, setAccount] = useState('')
    const [isDiffSameOrAfter, setDiff] = useState(true)
    const [datePickerErrorMessage, setDatePickerErrorMessage] = useState('');
    const [startDate, setStartDate] = useState(moment(moment().format(dateFormat), dateFormat))
    const [endDate, setEndDate] = useState(moment(moment().format(dateFormat), dateFormat))
    const [defeaultEndDate, setDefaultEndDate] = useState(businessDate)
    const [accountAllData, setAccountAllData] = useState<Array<any>>([]);
    const [cardstatementTransactions, setCardStatementTransactions] = useState<Array<any>>([])
    const [cardstatementHead, setCardStatementHead] = useState<Array<any>>([])
    const [iban, setIban] = useState('')
    const [user, setUser] = useState('')
    const [ownerAcc, setOwnerAcc] = useState('')
    const [voenacc, setVoenAcc] = useState('')
    const language = localStorage.getItem("i18nextLng")
    const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
    let channel = secureLocalStorageGet('channel')
    const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
    const [errorText, setErrorText] = useState<string>('')
    const [otpNumberCount, setOtpNumberCount] = useState<number>(5)
    const [otpCode, setOtpCode] = useState<number[]>([])
    const [typeButton, setTypeButton] = useState('')
    const [phoneNumber, setPhoneNumber] = useState<string>('')
    const [smsClicked, setClicked] = useState(true)
    const [reset, setReset] = useState<boolean>(false)

    let footerBtnsSecond = [
        {
            icon: <PdfIco />,
            title: t("accountStatement.downloadPDF"),
            type: "pdf",
            loading: false
        },
        {
            icon: <XlsIco />,
            title: t("transfers.downloadExcel"),
            type: "excel",
            loading: false
        },
    ]
    const [exportDetail, setExportDetail] = useState(footerBtnsSecond);
    const [selectedValue, setSelectedValue] = useState("AZ");
    const [lcValue, setLcValue] = useState(true);
    const [loading, setLoading] = useState(false)

    const { getCardStatementDataByPan } = useActions();

    const pageOptions = [10, 50, 100]
    const dateFilters = [
        {
            key: 1,
            label: t("transfers.today"),
            dateFrom: moment(moment().format(dateFormat), dateFormat),
            dateTo: moment(businessDate, dateFormat),
        },
        {
            key: 2,
            label: t("transfers.yesterday"),
            dateFrom: moment().add(-1, 'days'),
            dateTo: moment().add(-1, 'days'),
        },
        {
            key: 3,
            label: t("transfers.thisWeek"),
            dateFrom: moment().startOf('week').add(1, 'days'),
            dateTo: moment(businessDate, dateFormat),
        },
        {
            key: 4,
            label: t("transfers.lastWeek"),
            dateFrom: moment().subtract(1, 'weeks').startOf('week').add(1, 'days'),
            dateTo: moment().subtract(1, 'weeks').endOf('week').add(1, 'days'),
        },
        {
            key: 5,
            label: t("transfers.thisMonth"),
            dateFrom: moment().startOf('month'),
            dateTo: moment(businessDate, dateFormat),
        },
        {
            key: 6,
            label: t("transfers.lastMonth"),
            dateFrom: moment().subtract(1, 'months').startOf('month'),
            dateTo: moment().subtract(1, 'months').endOf('month'),
        },
        {
            key: 7,
            label: t("transfers.oneMonth"),
            dateFrom: moment().subtract(1, 'month'),
            dateTo: moment(businessDate, dateFormat),
        }
        ,
        {
            key: 8,
            label: t("accountStatement.currentQuarter"),
            dateFrom: moment().startOf('quarter'),
            dateTo: moment(businessDate, dateFormat),
        },
        {
            key: 9,
            label: t("accountStatement.previousQuarter"),
            dateFrom: moment().subtract(1, 'quarter').startOf('quarter'),
            dateTo: moment().subtract(1, 'quarter').endOf('quarter'),
        },
        {
            key: 10,
            label: t("accountStatement.thisYear"),
            dateFrom: moment().startOf('year'),
            dateTo: moment(businessDate, dateFormat),
        },
        {
            key: 11,
            label: t("accountStatement.1year"),
            dateFrom: moment().subtract(1, 'year'),
            dateTo: moment(businessDate, dateFormat),
        },
    ]

    const handleAccount = (value: any) => {
        setAccount(value.substring(0,19))

    }

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
    });
    useEffect(() => {
        if (businessDate !== null && businessDate !== undefined && businessDate !== "") {
            setDefaultEndDate(businessDate)
            setEndDate(moment(businessDate, "DD.MM.YYYY"));
            form.setFieldsValue({ endDate: moment(businessDate, "DD.MM.YYYY") });
        }
    }, [businessDate])
    useEffect(() => {
        if (otpCodeModalVisible) {
            setOtpCodeHasError(false)
            setErrorText('')
            setOtpCode([])
        }
    }, [otpCodeModalVisible])
    const getBussinessDateData = async () => {
        const bussinesDate = await getBusinessDate(language)
        setBusinessDate(bussinesDate)
        setEndDate(moment(bussinesDate, "DD.MM.YYYY"))

    }

    useEffect(() => {
        setAccount(location?.state?.card !== undefined ? location?.state?.card.card_pan : account)
        getBussinessDateData()
    }, [])

    const [filtereValues, setFilteredValues] = useState({ "col_2": "", "col_3": "", "col_4": "" })

    const handleFilterColumn = (e: any, column: string) => {

        let newfiltereValues = filtereValues;


        if (column === 'col_2') {
            newfiltereValues.col_2 = e.target.value?.toLowerCase()
            newfiltereValues.col_3 = ''
            newfiltereValues.col_4 = ''
            form.setFieldsValue({ "sender_getter": "" })
            form.setFieldsValue({ "patment_description": "" })
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_3') {
            newfiltereValues.col_3 = e.target.value?.toLowerCase()
            newfiltereValues.col_2 = ''
            newfiltereValues.col_4 = ''
            form.setFieldsValue({ "operation_number": "" })
            form.setFieldsValue({ "patment_description": "" })
            setFilteredValues(newfiltereValues)
        }

        if (column === 'col_4') {
            newfiltereValues.col_4 = e.target.value?.toLowerCase()
            newfiltereValues.col_2 = ''
            newfiltereValues.col_3 = ''
            form.setFieldsValue({ "sender_getter": "" })
            form.setFieldsValue({ "operation_number": "" })
            setFilteredValues(newfiltereValues)
        }


        if (tableDataMain && filtereValues) {

            let filteredData: any;

            filteredData = tableDataMain?.filter((sRow: any) => (sRow.col_2 ? sRow.col_2?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').
                includes(filtereValues["col_2"]) : filtereValues["col_2"] === '' ? sRow.col_2 === null : "") && (sRow.col_3 ? sRow.col_3?.toLowerCase().normalize().
                    replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_3"]) : filtereValues["col_3"] === '' ? sRow.col_3 === null : "") &&
                (sRow.col_4 ? sRow.col_4?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) :
                    filtereValues["col_4"] === '' ? sRow.col_4 === null : ""));



            setTableData(old_data => filteredData);
            setTableListForSortOriginal(old => filteredData)
            setPagination({
                ...pagination,
                current: 1
            })

        }
    }

    const columnsData = [
        {
            title: (
                <div className="flex">
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableListForSortOriginal}
                        type={"date"}
                        parameter={"col_1"}
                        // paramater_second={"date"}
                        hasTime={true}
                    />
                    <p>{t("common.date")}</p>
                </div>
            ),
            dataIndex: 'col_1',
            key: 'col_1',
            className: 'date',
            render: (data) => (
                <>
                    <p>{data === null || data === undefined ? " " : data}</p>
                </>
            ),
            ellipsis: true,
            width: 89,
            editable: false,
        },
        {
            title: (
                <div className="searchable-column">
                    <div className={'flex'}>
                        <Form
                            form={form}
                        >
                            <SearchableColumn
                                form={form}
                                name={"operation_number"}
                                filter={"searchfilter"}
                                title={t("accountStatement.transactionNumber")}
                                onChange={(event: any) => handleFilterColumn(event, 'col_2')}
                            />
                        </Form>

                    </div>
                </div>
            ),
            dataIndex: 'col_2',
            key: 'col_2',
            width: 181,
            ellipsis: true,
            editable: false,
            className: 'col_2 ant-table-cell-ellipsis',
            render: (text: string) => (
                <>
                    <p style={{ minWidth: 140, textAlign: "left" }}>{text}</p>
                </>
            ),
        },
        {
            title: (
                <div className="searchable-column">
                    <div className={'flex'}>
                        <Form
                            form={form}
                        >
                            <SearchableColumn
                                form={form}
                                name={"sender_getter"}
                                filter={"searchfilter"}
                                title={t("home.senderReceiver")}
                                onChange={(event: any) => handleFilterColumn(event, 'col_3')}
                            />
                        </Form>

                    </div>
                </div>
            ),
            dataIndex: 'col_3',
            key: 'col_3',
            ellipsis: true,
            editable: false,
            render: (text: string) => {
                return text?.length > 30 ? (
                    <CustomTooltip className="table-tooltip" title={text}>
                        <p style={{ minWidth: 140, maxWidth: 200 }}>{text}</p>
                    </CustomTooltip>
                ) : (
                    <p >{text}</p>
                )
            },
        },
        {
            title: (
                <div className="searchable-column">
                    <div className={'flex'}>
                        <Form
                            form={form}
                        >
                            <SearchableColumn
                                form={form}
                                name={"patment_description"}
                                filter={"searchfilter"}
                                title={t("accountStatement.paymentDetails")}
                                onChange={(event: any) => handleFilterColumn(event, 'col_4')}
                            />
                        </Form>

                    </div>
                </div>
            ),
            dataIndex: 'col_4',
            key: 'col_4',
            ellipsis: true,
            editable: false,
            render: (text: string) => {
                return text?.length > 30 ? (
                    <CustomTooltip className="table-tooltip" title={text}>
                        <p style={{ minWidth: 140, maxWidth: 'max-content' }}>{text}</p>
                    </CustomTooltip>
                ) : (
                    <p style={{ minWidth: 140, maxWidth: 'max-content' }}>{text}</p>
                )
            },
        },
        {
            title: (
                <div className={'flex justify_end'}>
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableListForSortOriginal}
                        type={"number"}
                        parameter={"col_5"}
                    />
                    <p>{t("home.credit")}</p>
                </div>
            ),
            dataIndex: 'col_5',
            key: 'col_5',
            width: 181,
            ellipsis: true,
            editable: false,
            render: (data: string) => {
                let p_classname = parseFloat(data) > 0 ? 'is_blue' : 'is_grey';
                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>{data}</p>
                    </>
                )
            },
        },
        {
            title: (
                <div className={'flex justify_end'}>
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableListForSortOriginal}
                        type={"number"}
                        parameter={"col_6"}
                    />
                    <p>{t("home.debit")}</p>
                </div>
            ),
            dataIndex: 'col_6',
            key: 'col_6',
            width: 181,
            ellipsis: true,
            editable: false,
            render: (data: string) => {
                let p_classname = parseFloat(data) > 0 ? 'is_red' : 'is_grey';
                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>{data}</p>
                    </>
                )
            },
        },

    ]

    const handleDateData = (key: number) => {
        setDateIndex(key)
    }

    const handleStartDate = (date: moment, dateString: string) => {

        setStartDate(date)
        if (date) {
            handleDateData(0)
        }
    }

    const handleEndDate = (date: moment, dateString: string) => {
        setEndDate(date)
        if (date) {
            handleDateData(0)
        }

    }

    const handleFilter = (values: any) => {
        handleFilter(values)
    }

    useEffect(() => {
        if (account === null || account === undefined) {
            setTableData([])
        }
        if (!(moment(endDate).isSameOrAfter(startDate))) {
            setDiff(false);
            setDatePickerErrorMessage(t("transfers.startDateCantBeLaterThanEndDate"));
        } else if (!(moment(endDate).isSameOrAfter(moment().subtract(5, 'year'))) || !(moment(startDate).isSameOrAfter(moment().subtract(5, 'year')))) {
            setDiff(false);
            setDatePickerErrorMessage(t("accountStatement.max5years"));
        }
        else if (!(moment(startDate).isSameOrAfter(moment(endDate).subtract(1, 'year')))) {
            setDiff(false);
            setDatePickerErrorMessage(t("accountStatement.maxPeriod"));
        }
        else {
            setDiff(true);
            setDatePickerErrorMessage("");
        }


    }, [startDate, endDate])

    const handleDateFilterData = (key: number, dateFrom: Date, dateTo: Date) => {
        setStartDate(moment(dateFrom))
        setEndDate(moment(dateTo))
        form.setFieldsValue({ startDate: dateFrom, endDate: dateTo })
        handleDateData(key)
    }

    useEffect(() => {
        setAccountAllData(accountArray)
        setAccountOptions(accountArray)

        try {
            if (cardsStatementData !== null && cardsStatementData !== undefined) {
                setCardStatementTransactions(cardsStatementData?.Transactions)
                setCardStatementHead(cardsStatementData?.Head)
                // @ts-ignore
            }
        } catch (e) {

        }
    }, [cardsStatementData])

    useEffect(() => {
        setAccountOptions(accountArray)

    }, [accountArray])
    const infoData = {
        leftColumnData: [
            { title: t("salary.accountHolder"), value: ownerAcc, key: 'SenderReceiver' },
            { title: t("requisites.taxID"), value: voenacc, key: 'taxNo' },
            { title: 'IBAN', value: iban, key: 'IBAN' },
            { title: t('businessCards.cardNumberPANandUser'), value: user, key: 'pan' }
        ],
        rightColumnData: [
            { title: t("accountStatement.creditTurnover"), value: financial(cardstatementHead?.KreditTurnover), key: 'crBalance' },
            { title: t("accountStatement.debitTurnover"), value: financial(cardstatementHead?.DebetTurnover), key: 'drBalance' },
            { title: t('home.balance'), value: cardstatementHead?.Balance, key: 'balance' },
            { title: t("accountStatement.currencyCode"), value: cardstatementHead?.Currency, key: 'ccyType' },
        ],
    }

    useEffect(() => {
        let temp_array = [];
        if (cardstatementHead !== null && cardstatementHead !== undefined && cardstatementTransactions !== null && cardstatementTransactions !== undefined) {
            cardstatementTransactions?.map((transactionLine: any) => {
                let date = transactionLine?.Date

                temp_array.push({
                    col_1: date,
                    col_2: transactionLine?.Ref,
                    col_3: transactionLine?.SenderReceiver,
                    col_4: transactionLine.Description === null ? "" : transactionLine.Description,
                    col_5: transactionLine.Type === "C" ? financial(transactionLine.Amount) : 0.00,
                    col_6: transactionLine.Type === "D" ? financial(transactionLine.Amount) : 0.00,
                });
            })

        }
        setTableData(old_data => temp_array);
        setTableListForSortOriginal(old_data => temp_array)
        setTableDataMain(old_data => temp_array);
    }, [cardstatementHead, cardstatementTransactions, getCurrentCompany()],)

    const handleTableChange = (
        newPagination: any,
    ) => {
        setPagination({
            ...pagination,
            current: newPagination.current
        })
    };

    const applyFunc = async () => {
        const company = getCurrentCompany()
        setOwnerAcc(company.name)
        setVoenAcc(company.organizationCode)
        // console.log(accountAllData)
        const iban = accountAllData.find(c => c.pan === account)?.IBAN
        setIban(iban)
        const user = accountAllData.find(c => c.pan === account)?.label
        setUser(user)
        const type = accountAllData.find(c => c.pan === account)?.TYPE
        const formData = {
            startDate: startDate,
            endDate: endDate,
            pan: account,
            type: type
        }

        const limitDate = moment().subtract(180, 'days').startOf('day');

        const isOldDate = moment(startDate, dateFormat).isBefore(limitDate) ||
            moment(endDate, dateFormat).isBefore(limitDate);
        if (false){
            const userData: any = await getLoggedUserInfo()
            let phone_number = userData?.phoneNumber
            let last_4_number = phone_number?.slice(-4)
            let make_phone_number = last_4_number && last_4_number.length >= 4
              ? last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
              : ''
            setPhoneNumber(make_phone_number)
            getCardStatementDataByPan({ company: getCurrentCompany(), formData: formData });

            setOtpCodeModalVisible(true);
            // Table-ın avtomatik dolmaması üçün bura stop qoyuruq
        } else {
            // Normal hal və ya artıq OTP daxil edilibsə
            getCardStatementDataByPan({ company: getCurrentCompany(), formData: formData, });

        }



    }
    const handleValue = (value: any) => {
        setOtpCode(value)
        setOtpCodeHasError(false)
        setErrorText('')
    }
    const hideOtpCodeModal = () => {
        const newExportDedatil = [...exportDetail];
        newExportDedatil[0]["loading"] = false;
        newExportDedatil[1]["loading"] = false;
        setExportDetail(newExportDedatil)
        setOtpCode([])
        setErrorText('')
        setOtpCodeHasError(false)
        setOtpCodeModalVisible(false)
    }
    const checkOTPCode = async () => {
        setLoading(true)

        const type = accountAllData.find(c => c.pan === account)?.TYPE;
     

        try {
            if (typeButton === 'pdf') {
                const type = accountAllData.find(c => c.value === account).TYPE
                const customerNo = getCurrentCompany().customerNo

                const formData = {
                    startDate: startDate,
                    endDate: endDate,
                    customerNo: customerNo,
                    iban: account,
                    cardType: type
                }
                const newExportDedatil = [...exportDetail];
                newExportDedatil[0]["loading"] = true;
                setExportDetail(newExportDedatil)
                

                const data = await getCardExtrePdfByPan(formData, selectedValue, otpCode)
                downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);

            }
            else if (typeButton === 'excel') {
                const customerNo = getCurrentCompany().customerNo

                const formData = {
                    startDate: startDate,
                    endDate: endDate,
                    customerNo: customerNo,
                    iban: account,
                    cardType: 'NEW'
                }

                const newExportDedatil = [...exportDetail];
                newExportDedatil[1]["loading"] = true;
                setExportDetail(newExportDedatil)
             


                const data = await getCardExtreExcelByPan(formData, selectedValue, otpCode)
                downloadExcel(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);


            } else {
                const formData = {
                    startDate: startDate,
                    endDate: endDate,
                    pan: account,
                    type: type
                };
                await (getCardStatementDataByPan as any)({
                    company: getCurrentCompany(),
                    formData: formData,
                    otp: otpCode
                });
            }
            setOtpCodeModalVisible(false)
            const newExportDedatil = [...exportDetail];
            newExportDedatil[0]["loading"] = false;
            newExportDedatil[1]["loading"] = false;
            setExportDetail(newExportDedatil)
            setOtpCode([])
         
            setLoading(false)

        } catch (error: any) {
            console.log("Xəta tutuldu:", error)
            if (error !== null) {
                setOtpCodeHasError(true);
                setErrorText(error?.data?.detail)
                setLoading(false)

            } else {
                console.error("Başqa bir sistem xətası.");
            }
        }
    };

    const selectOptions = ['AZ', 'EN', 'RU'];
    const handleChangeSelect = (value: string) => {

        setSelectedValue(value)
    };

    const exportFile = async (typeClick: string) => {
        const customerNo = getCurrentCompany().customerNo
        const found = accountAllData.find(c => c.value === account)
        const type = found?.TYPE
        const formData = {
            startDate: startDate,
            endDate: endDate,
            customerNo:customerNo,
            pan: found?.encryptedPan || account,
            cardType:type
        }
        const userData: any = await getLoggedUserInfo()
        let phone_number = userData?.phoneNumber
        let last_4_number = phone_number?.slice(-4)
        let make_phone_number = last_4_number && last_4_number.length >= 4
          ? last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
          : ''
        setPhoneNumber(make_phone_number)
        if (typeClick === "pdf") {
            const newExportDedatil = [...exportDetail];
            newExportDedatil[0]["loading"] = true;
            setExportDetail(newExportDedatil)
            const data = await getCardExtrePdfByPan(formData, selectedValue)
            downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
        } else if (typeClick === "excel") {
            const newExportDedatil = [...exportDetail];
            newExportDedatil[1]["loading"] = true;
            setExportDetail(newExportDedatil)
            const data = await getCardExtreExcelByPan(formData, selectedValue)
            downloadExcel(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);
        }

        const newExportDedatil = [...exportDetail];
        newExportDedatil[0]["loading"] = false;
        newExportDedatil[1]["loading"] = false;
        setExportDetail(newExportDedatil)
    }

    function downloadPDF(fileName: string, fileBase64: string) {
        const linkSource = `data:application/pdf;base64,${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    function downloadExcel(fileName: string, fileBase64: string) {
        const linkSource = `data:application/vnd.ms-excel;base64,${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
  const resetFormTimer = () => {
    setOtpCodeModalVisible(false)
  }
const reSend = () => {
    if (smsClicked) {
      setClicked(false)
    const company = getCurrentCompany()

     const type = accountAllData.find(c => c.pan === account)?.TYPE
        const formData = {
            startDate: startDate,
            endDate: endDate,
            pan: account,
            type: type
        }
        getCardStatementDataByPan({ company: getCurrentCompany(), formData: formData });

    }
    // setMinutes(5);
    // setReset(true);
    // setTimeout(() => setReset(false), 1000);
  }

  useEffect(() => {
    if (!smsClicked) {
      let timer1 = setInterval(() => setClicked(true), 20 * 1000)
      return () => {
        clearInterval(timer1)
      }
    }
  }, [smsClicked])

    return (
        <div className='transfer_child_tabs' ref={ref}>
            <Col
                span={24}
                style={{ backgroundColor: '#fff', borderRadius: 10 }}
                className="account-statemant cardStatement"
            >
                <div className="transfers__filter">
                    <Form className="fullWidth" form={form} onFinish={handleFilter}>
                        <Row justify="start">
                            <Row align="top">
                                <Col style={{ marginRight: '30px' }}>
                                    <div className="pickers flex">
                                        <label>{t("transfers.period")}</label>
                                        <div
                                            className="pickers__width flex"
                                            style={{ width: '287px', position: 'relative', height: 40 }}
                                        >
                                            <div>
                                                <Form.Item name="startDate">
                                                    <DatePicker
                                                        style={{ float: 'left' }}
                                                        locale={locale}
                                                        defaultValue={moment(moment(startDate), dateFormat)}
                                                        className={
                                                            !isDiffSameOrAfter ? 'errored-ant-picker' : ''
                                                        }
                                                        onChange={handleStartDate}
                                                        suffixIcon={null}
                                                        value={moment(startDate).format(dateFormat)}
                                                        format={dateFormat}
                                                        allowClear={false}
                                                    />
                                                </Form.Item>
                                                {!isDiffSameOrAfter && (
                                                    <CustomTooltip
                                                        className="error-tooltip"
                                                        trigger="hover"
                                                        title={datePickerErrorMessage}
                                                    // title={t("transfers.startDateCantBeLaterThanEndDate")}
                                                    >
                                                        <div className="error-tooltip__icon error-tooltip__icon--left bt-44">
                                                            <ErrorNotificationIco />
                                                        </div>
                                                    </CustomTooltip>
                                                )}
                                            </div>
                                            <span style={{ margin: 'auto 10px' }}>-</span>
                                            <div>
                                                <Form.Item name="endDate">
                                                    <DatePicker
                                                        locale={locale}
                                                        style={{ float: 'right' }}
                                                        defaultValue={defeaultEndDate}
                                                        className={
                                                            !isDiffSameOrAfter ? 'errored-ant-picker' : ''
                                                        }
                                                        onChange={handleEndDate}
                                                        value={endDate}
                                                        suffixIcon={null}
                                                        format={dateFormat}
                                                        allowClear={false}
                                                    />
                                                </Form.Item>
                                                {!isDiffSameOrAfter && (
                                                    <CustomTooltip
                                                        className="error-tooltip"
                                                        trigger="hover"
                                                        title={datePickerErrorMessage}
                                                    >
                                                        <div className="error-tooltip__icon error-tooltip__icon--left bt-44">
                                                            <ErrorNotificationIco />
                                                        </div>
                                                    </CustomTooltip>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col style={{ display: 'flex', alignItems: 'center' }}>
                                    <SelectField
                                        name="account"
                                        labelItem={t("businessCards.cardNumberPANandUser")}
                                        placeholder={t("accountStatement.chooseAccount")}
                                        options={selectAccountOptions}
                                        value={location?.state?.card !== undefined ? location?.state?.card.card_pan : account}
                                        defaultValue={location?.state?.card !== undefined ? location?.state?.card.card_number : account}
                                        showSearch={true}
                                        onChange={(args: any) => handleAccount(args)}
                                        defaultActiveFirstOption={false}
                                        dropdownClassName="transfers-dropdown accountStatement-dropdown"
                                        optionLabelProp="label"
                                        defaultOpen={true}
                                        width={400}
                                        kod={true}
                                        code={true}
                                        // defaultValue = {ibanNumber.iban}
                                        page={"accountStatement"}
                                    />
                                </Col>
                            </Row>

                            <Col
                                style={{
                                    marginLeft: 'auto',
                                    // display: 'flex',
                                    // alignItems: 'center',
                                }}
                            >
                                <div className="flex pagination-selector account-pagination-selector">
                                    <p>{t("salary.numberAtPage")} </p>
                                    <Select
                                        defaultValue={50}
                                        dropdownClassName={'hoverable pagination-select'}
                                    // onChange={changePageSize}
                                    >
                                        {pageOptions.map((item) => {
                                            return <option value={item}>{item}</option>
                                        })}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <Row
                    className='accountStatement-filter-secondRow'
                >
                    <Col>
                        <ul className="dates-list flex accountStatement-dates-list">
                            {dateFilters.map((item, index) => {
                                return (
                                    <li
                                        className={index + 1 == activeIndexDate ? 'active' : ''}
                                    >
                                        <p
                                            onClick={() =>
                                                handleDateFilterData(item.key, item.dateFrom, item.dateTo)
                                            }
                                        >
                                            {item.label}
                                        </p>
                                    </li>
                                )
                            })}
                        </ul>
                    </Col>

                    <Col>
                        <Button htmlType="submit" className="blue-button accountStatement-blue-button" onClick={applyFunc} disabled={account !== "" && isDiffSameOrAfter ? false : true} >
                            {t("accountStatement.apply")}
                        </Button>
                    </Col>
                </Row>
                {

                    tableData?.length !== 0 ?
                        <Col>
                            <Row className="account-statement-info-Mainrow">
                                <Col span={12}>
                                    {infoData.leftColumnData.map((item: any) => {
                                        return (
                                            <>
                                                <Row className="account-statement-info-row-first">
                                                    <Col style={{ width: "300px" }} className={"account-statement-info-row-first__title"}>{item.title}</Col>

                                                    {
                                                        item.value !== null ?
                                                            <CustomToolTip className="table-tooltip" title={item.value}>
                                                                <Col className={"account-statement-info-row-first__value"}>{item.value}</Col>
                                                            </CustomToolTip> : <Col className={"account-statement-info-row-first__value"}>{item.value}</Col>
                                                    }

                                                </Row>
                                            </>
                                        )
                                    })}
                                </Col>
                                <Col span={8}>
                                    {infoData.rightColumnData.map((item: any) => {
                                        return (
                                            <>
                                                <Row className="account-statement-info-row">
                                                    <Col span={12} className={"account-statement-info-row__title"}>{item.title}</Col>
                                                    <Col span={12} className={item.key === "crBalance" ? "accountStatementInfo account-statement-info-row__value is_blue" : item.key === "drBalance" ? "accountStatementInfo account-statement-info-row__value is_red" : "accountStatementInfo account-statement-info-row__value"} >{item.value}</Col>
                                                </Row>
                                            </>
                                        )
                                    })}
                                </Col>
                            </Row>

                            <Col
                                className="salary-transfer__table__divider accountStatement-table"
                                style={{ minHeight: '500px' }}
                            >
                                {

                                    (tableDataMain?.length > 0 && tableDataMain !== null) ?
                                        <Table
                                            pagination={
                                                {
                                                    pageSize: pagination.pageSize,
                                                    current: pagination.current,
                                                    onChange: handleTableChange,
                                                }
                                            }
                                            // loading={tableLoading}
                                            columns={columnsData}
                                            dataSource={tableData}
                                            // rowClassName={rowClassName}
                                            className='transfer-table salary-table transfers-table__component home_account_opt_table account_statement_pagination'
                                            scroll={{ x: true }}

                                        /> :
                                        <Row className='accountStatement-nodata-row'>
                                            <Row className='accountStatement-nodata-row__text'>
                                                {t("accountStatement.noTransactionDuringPeriodNote")}
                                            </Row>
                                        </Row>
                                }

                            </Col>
                            <Row style={{ marginBottom: "30px" }}>
                                <Col span={12} style={{ display: 'flex' }}>
                                    <div className="flex">
                                        <div
                                            className="accountStatement-footer_btns transfers-footer_btns flex"
                                        >
                                            <ul
                                                className="flex"
                                            >
                                                <li>
                                                    <div className="pagination-selector" style={{ left: '0px' }}>
                                                        <Select defaultValue={selectedValue} placeholder="AZ" width={64} onChange={handleChangeSelect} disabled={tableData ? false : true}>
                                                            {selectOptions.map((item) => {
                                                                return <option value={item}>{item}</option>
                                                            })}
                                                        </Select>
                                                    </div>
                                                </li>
                                                {exportDetail.map((item) => {
                                                    return (
                                                        <li>
                                                            <Tooltip className="footer-tooltip" title={item.title}>

                                                                {
                                                                    item.loading ? <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div> :
                                                                        <Button className={"accountPage_exportButtons"} ghost icon={item.icon} onClick={() => exportFile(item.type)} disabled={tableData ? false : true} />
                                                                }
                                                            </Tooltip>
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col> :
                        (user === '' ? <Col
                            className="salary-transfer__table__divider accountStatement-table"
                            style={{ minHeight: '628px' }}
                        >
                        </Col> : <Row className='accountStatement-nodata-row' style={{ marginTop: "25px" }}>
                            <Row className='accountStatement-nodata-row__text'>
                                {t("accountStatement.noTransactionDuringPeriodNote")}
                            </Row>
                        </Row>)

                }
            </Col>
            {otpCodeModalVisible && (
                <Modal
                    title={
                        t('transfers.signingBySMSCode')
                    }
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={otpCodeModalVisible}
                    onOk={hideOtpCodeModal}
                    onCancel={hideOtpCodeModal}
                    width={422}
                    className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={false}
                    maskClosable={false}
                >
                    <div
                        className={
                            'flex direction_column align_center otp_code_verify_modal_body'
                        }
                    >
                        <p>
                                {t('settings.otpcode1')}
                                {phoneNumber} {t('settings.otpcode2')} <br />
                                {t('settings.otpcode3')}
                            </p>
                        <Form
                            form={form}
                            onSubmit={(e: any) => e.preventDefault()}
                            onFinish={checkOTPCode}
                            shouldAutoFocus={true}
                            autoComplete="off"
                            className={
                                otpCodeHasError
                                    ? 'message-input-form flex direction_column justify_center has_error'
                                    : 'flex direction_column justify_center message-input-form'
                            }
                        >
                            <OtpInput
                                value={otpCode}
                                onChange={handleValue}
                                numInputs={otpNumberCount}
                                inputStyle="otpInput"
                                isInputNum={true}
                                shouldAutoFocus={true}
                                className="message-input-form__input"
                            />

                            {otpCodeHasError && (
                                <span className={'verify_code_error flex full justify_center'}>
                                    {errorText}
                                </span>
                            )}

                            <div className={'full flex direction_column'}>
                                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    <Timer timerEnd={resetFormTimer} reset={reset} />
                  </li>
                  <li>
                   
                      <a
                        onClick={reSend}
                        className={smsClicked ? 'active' : 'disabled'}
                      >
                        {t('modal.detailsData')}
                      </a>
                    
                  </li>
                </ul>

                                {/*<Button*/}
                                {/*  type={'ghost'}*/}
                                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                                {/*  onClick={reSend}*/}
                                {/*>*/}
                                {/*  SMS kodu yenidən göndər*/}
                                {/*</Button>*/}

                                <div className="login-form__buttons flex justify_center">
                                    <Button
                                        size={'large'}
                                        className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                                        onClick={hideOtpCodeModal}
                                    >
                                        {t('transfers.back')}
                                    </Button>
                                    <Button
                                        size={'large'}
                                        className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                                        htmlType="submit"
                                        loading={loading}
                                    >
                                        {t('login.confirm')}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal>
            )}
            {
                inProgress ? <FullScreenLoading /> : <></>
            }
        </div>
    )
};


const mapDispatchToProps = { getCardStatementData, setCardArray, getCardStatementDataByPan }

const mapStateToProps = (state: any) => ({
    cardsStatementData: state.cardsStatement.cardsStatementData.result ?? [],
    inProgress: state.cardsStatement.inProgress,
    accountArray: state.cardsStatement.accountArray
})
export default connect(mapStateToProps, mapDispatchToProps)(CardStatement)